import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconVideo2"><Path d="M14.75 4.5C16.2688 4.5 17.5 5.73122 17.5 7.25V16.75C17.5 18.2688 16.2688 19.5 14.75 19.5H4.75C3.23122 19.5 2 18.2688 2 16.75V7.25C2 5.73122 3.23122 4.5 4.75 4.5H14.75Z" fill="currentColor"/><Path d="M20.4434 7.21484C21.4284 6.82118 22.4998 7.54658 22.5 8.60742V15.3926C22.4998 16.4534 21.4284 17.1788 20.4434 16.7852L18.5 16.0078V7.99219L20.4434 7.21484Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2;
